export default __webpack_public_path__ + "static/dark-elves-3854c61ac886aa4ce5432070895ce7fb.webp";